import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Box, Alert, } from "@mui/material";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import "./ProjectDelete.css";

export default function SubprojectCodeDelete({
  open,         // controlează deschiderea dialogului
  onClose,      // funcție apelată la închiderea dialogului
  onConfirm,    // funcție apelată la confirmarea ștergerii
  subproject,   // obiectul subproject care urmează să fie șters
  deleteError,  // flag/mesaj care indică dacă ștergerea a eșuat
}) {

  // Mesaj standard afișat dacă ștergerea nu este permisă
  const errorMessage =
    "Cannot delete this subproject code because it has dependencies in other records. Please remove or update those dependencies first.";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      className="subproject-delete-dialog"
      PaperProps={{
        elevation: 24,
        sx: {
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      {/* Headerul se afișează doar dacă NU există eroare la ștergere */}
      {!deleteError && (
        <DialogTitle className="spd-header">
          <Box className="spd-header-content">
            <Box className="spd-title-section">
              {/* Icon de avertizare */}
              <WarningAmberIcon className="spd-warning-icon" />

              {/* Titlul dialogului */}
              <Typography variant="h5" component="span" className="spd-title">
                Delete Subproject
              </Typography>
            </Box>

            {/* Buton de închidere */}
            <IconButton
              onClick={onClose}
              className="spd-close-btn"
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
      )}

      <DialogContent className="spd-content">
        {deleteError ? (
          // Dacă există eroare, afișăm un mesaj de alertă
          <Alert
            severity="error"
            className="spd-error-alert"
            icon={<ErrorOutlineIcon />}
          >
            <Typography variant="body1" fontWeight={500}>
              Unable to Delete Subproject
            </Typography>

            <Typography variant="body2" className="spd-error-message">
              {errorMessage}
            </Typography>
          </Alert>
        ) : (
          // Dacă nu există eroare, afișăm conținutul de confirmare
          <Box className="spd-confirm-content">
            {/* Afișare cod subproject */}
            <Box className="spd-code-container">
              <Typography variant="subtitle2" className="spd-code-label">
                Subproject Code
              </Typography>

              <Typography variant="h6" className="spd-code-value">
                {subproject?.code}
              </Typography>
            </Box>

            {/* Mesaj de avertizare principal */}
            <Typography variant="body1" className="spd-warning-text">
              This action is permanent and cannot be undone.
            </Typography>

            {/* Lista consecințelor ștergerii */}
            <Box className="spd-consequences">
              <Typography variant="body2" className="spd-consequence-item">
                • All associated data will be permanently deleted
              </Typography>

              <Typography variant="body2" className="spd-consequence-item">
                • Related configurations will be removed
              </Typography>

              <Typography variant="body2" className="spd-consequence-item">
                • This change cannot be reversed
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>

      <DialogActions className="spd-actions">
        {deleteError ? (
          // Dacă există eroare, utilizatorul vede doar un buton de închidere
          <Button
            onClick={onClose}
            variant="contained"
            className="spd-btn spd-btn-ok"
          >
            Got It
          </Button>
        ) : (
          // Dacă nu există eroare, afișăm butoanele normale de confirmare
          <>
            <Button
              onClick={onClose}
              variant="outlined"
              className="spd-btn spd-btn-cancel"
            >
              Cancel
            </Button>

            <Button
              onClick={onConfirm}
              variant="contained"
              className="spd-btn spd-btn-delete"
              startIcon={<DeleteOutlineIcon />}
              autoFocus
            >
              Delete
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}